//add date picker functionality
blue.ready('customDatePicker', '.datePicker input', (datePicker) => {
	blue.plug.pickit(datePicker);
})

//add file upload functionality
blue.ready('fileUpload', '.fileUpload input', (input) => {
	blue.plug.upload(input)
})

//add validation functionality
blue.ready('formValidate', '.formValidate', (form) => {
	blue.plug.validate(form)
})

//add date mask functionality
blue.ready('customDateMask', '.dateMask input', (dateMask) => {
	blue.plug.inputMask(dateMask);
})